import { useState } from 'react'
import { Card, CardContent } from '@/components/ui/card'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

import { CreditControlTab } from './credit-control'

interface MonthlyCredit {
  id: string
  month: string
  totalUsed: number
  items: CreditItem[]
  files: File[]
}

interface CreditItem {
  id: string
  verba: string
  value: number
}

export default function FCVSApp() {
  const [debitosCorrentes, setDebitosCorrentes] = useState<MonthlyCredit[]>([])
  const [debitosVencidosRFB, setDebitosVencidosRFB] = useState<MonthlyCredit[]>([])
  const [debitosPGFN, setDebitosPGFN] = useState<MonthlyCredit[]>([])

  // Calcula o total utilizado de todas as abas
  // const getTotalUsed = () => {
  //   const totalCorrentes = debitosCorrentes.reduce((sum, item) => sum + item.totalUsed, 0)
  //   const totalVencidos = debitosVencidosRFB.reduce((sum, item) => sum + item.totalUsed, 0)
  //   const totalPGFN = debitosPGFN.reduce((sum, item) => sum + item.totalUsed, 0)
  //   return totalCorrentes + totalVencidos + totalPGFN
  // }

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-6xl mx-auto space-y-6">
        <Card>
          <CardContent className="p-0">
            <Tabs defaultValue="correntes" className="w-full">
              <TabsList className="grid w-full grid-cols-3 rounded-none border-b">
                <TabsTrigger value="correntes" className="rounded-none">
                  Débitos Correntes
                </TabsTrigger>
                <TabsTrigger value="vencidos" className="rounded-none">
                  Débitos Vencidos RFB
                </TabsTrigger>
                <TabsTrigger value="pgfn" className="rounded-none">
                  Débitos PGFN
                </TabsTrigger>
              </TabsList>

              <TabsContent value="correntes" className="p-6">
                <CreditControlTab data={debitosCorrentes} setData={setDebitosCorrentes} title="Débitos Correntes" />
              </TabsContent>

              <TabsContent value="vencidos" className="p-6">
                <CreditControlTab
                  data={debitosVencidosRFB}
                  setData={setDebitosVencidosRFB}
                  title="Débitos Vencidos RFB"
                />
              </TabsContent>

              <TabsContent value="pgfn" className="p-6">
                <CreditControlTab data={debitosPGFN} setData={setDebitosPGFN} title="Débitos PGFN" />
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
